<template>
	<div>
		<div style="width: 70%;min-width: 600px; display: flex;justify-content: space-between;margin-left: 8%;align-items: center;">
			<div @mouseover="navigateState=0" @click="goToPath('/')" :class="states=='index'?'menuItems':'menuItems black'">
				首页
				<div style="padding-bottom: 9px;"></div>
				<div :class="states=='index'&&currentUrl=='/'?'indexItems':''" style="width: 20px;height: 3px;">

				</div>

			</div>
			<div :class="states=='index'?'indexItems':''" style="width: 1px;height: 16px;">

			</div>
			<div @mouseover="changeMenus('center')" @click="goToPath('/centerLab')"
				:class="states=='index'?'menuItems':'menuItems black'">
				中心实验室
				<div style="padding-bottom: 9px;"></div>
				<div :class="currentUrl=='/centerLab'||currentBigUrl=='center'?'orderItems':''"
					style="width: 20px;height: 3px;">

				</div>

			</div>

			<div :class="states=='index'?'indexItems':''" style="width: 1px;height: 16px;">

			</div>
			<div @mouseover="changeMenus('animal')" @click="goToPath('/animalLab')"
				:class="states=='index'?'menuItems':'menuItems black'">
				动物实验中心
				<div style="padding-bottom: 9px;"></div>
				<div :class="currentUrl=='/animalLab'||currentBigUrl=='animal'?'orderItems':''"
					style="width: 20px;height: 3px;">

				</div>

			</div>
			<div :class="states=='index'?'indexItems':''" style="width: 1px;height: 16px;">

			</div>
			<div @mouseover="changeMenus('point')" @click="goToPath('/pointLab')"
				:class="states=='index'?'menuItems':'menuItems black'">
				省重点实验室
				<div style="padding-bottom: 9px;"></div>
				<div :class="currentUrl=='/pointLab'?'orderItems':''" style="width: 20px;height: 3px;">

				</div>

			</div>
			<div :class="states=='index'?'indexItems':''" style="width: 1px;height: 16px;">

			</div>
			<div @mouseover="navigateState=0" @click="goToPath('/orderLab')" :class="states=='index'?'menuItems':'menuItems black'">
				其他科研平台
				<div style="padding-bottom: 9px;"></div>
				<div :class="currentUrl=='/orderLab'?'orderItems':''" style="width: 20px;height: 3px;"></div>
			</div>
		</div>
		
		<div @mouseover="navigateState=1" @mouseleave="navigateState=0"
			:class="navigateState==1?'animate__animated animate__fadeIn':'animate__animated animate__fadeOut'"
			v-if="navigateState!=0"
			style=" width: 58%;min-height: 100px;background: #FBFBFB;position: absolute;top: 100px;z-index: 100;right: 0;">
			<div :style="currentSmallUrl=='point'?'width:50%;':''" class="ggs">
				<!-- currentUrl=='/IACUC' -->
				<div @click="goToPathNext(item.path)" 
					:class="item.path==currentUrl?'actives kk':item.path.split('?id=')[0]=='/pointLab'&&(item.path.split('?id=')[1]==$route.query.id)?'actives kk':item.path=='animalApply'&&(currentUrl=='/aniQualification'||currentUrl=='/animalApply')?'actives kk':'naItems kk'"
					v-for="item in centerData"
					@mouseover="menuNextOver(item.path)"
					@mouseleave="menuNextOver2(item.path)"
					:style="currentSmallUrl=='point'?'width:100%;':item.path==''?'pointer-events: none;':''">
					<div v-if="item.path!=''" style="display: flex;justify-content: center;align-items: center;">
						<img  class="yincang" style="width: 14px;" src="../../assets/images/下箭头@2x.png">
						<img v-if="item.path!=currentUrl" class="zhengc" style="width: 14px;" src="../../assets/images/下箭头@2xdd.png">
						<img v-if="item.path==currentUrl"  style="width: 14px;" src="../../assets/images/下箭头@2x.png">
						 <span style="padding-left: 12px;">{{item.title}}</span>
					</div>
					<div v-if="item.path==''" style="pointer-events: none;background-color: transparent !important;">
						
					</div>
					<div @mouseleave="this.menuNext=false" v-show="menuNext" @click.stop="ddd" v-if="item.path=='animalApply'" style="position: absolute;background: #FFFFFF;width: 100%;height: 168px;top: 60px;z-index: 100;left: 0;border-radius: 0px 0px 8px 8px;box-shadow: 0px 8px 32px 0px rgba(0, 0, 0, 0.16);">
						<div style="color: #333333 !important;font-size: 16px !important;display: flex;flex-direction: column;justify-content: space-evenly;height: 100%;margin-left: 80px;">
							<!-- <div  @click="goToMenuNext('1')" :class="currentUrl=='/IACUC'?'hoverdd activesd':'hoverdd'">IACUC审查</div> -->
							<div @click="goToMenuNext('2')" :class="currentUrl=='/aniQualification'?'hoverdd activesd':'hoverdd'">动物实验中心入室申请</div>
							<div @click="goToMenuNext('3')" :class="currentUrl=='/animalApply'?'hoverdd activesd':'hoverdd'" >动物订购申请</div>
						</div>
					</div>
					
					
				</div>
				<div style="width:100%;height: 100%;background: #F2F2F2;position: absolute;left: -100%;top: 0;display: flex;align-items: center;justify-content: center;">
					<img src="../../assets/images/Vectordd.png" style="width: 22px;height: 22px;">
					<div style="margin-left: 17px;font-size: 28px;color: #165FDC;">
						{{currentSmallUrl=='center'?'中心实验室':currentSmallUrl=='animal'?'动物实验中心':'省重点实验室'}}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		Dynamic,
		AllLabProvincialKeyPoints
	} from '@/api/index.js'
	export default {
		data() {
			return {
				currentUrl: '',
				menuNext:false,
				pointDatas:[],
				currentBigUrl: window.localStorage.getItem('currentBigUrl'),
				currentSmallUrl: '',
				states: '',
				navigateState: 0,
				centerData: [{
						title: '中心介绍',
						path: '/centerLab'
					},
					{
						title: '中心实验室入室申请',
						path: '/coreQualification'
					},
					{
						title: '资讯',
						path: '/notice'
					},
					
					{
						title: '仪器预约',
						path: '/instrument'
					},
					{
						title: '学习园地',
						path: '/downLoad'
					},
					{
						title: '门禁预约',
						path: '/accessControl'
					},
					{
						title: '耗材&项目',
						path: '/consumable'
					},
				]
			}
		},
		watch: { //动态监听路由变化 -以便动态更改导航背景色事件效果等
			'$route'(to, from) {
				// 对路由变化作出响应...
				let current1 = this.$route.path
				
				this.currentUrl = current1
				console.log(current1)
				if (current1 == '/') {
					this.states = 'index'
					this.currentBigUrl = ''
				} else if (current1 == '/orderLab') {
					this.currentBigUrl = ''
					this.currentUrl = '/orderLab'
					this.states = 'order'
				}
				 
				 else {
					this.states = ''
				}
			}
		},
		created() {
			if(this.$route.path=='/pointLab'&&!this.$route.query.id){
				AllLabProvincialKeyPoints().then((res)=>{
					this.pointDatas = res.data.data[0]
				})
			}
			else{
				AllLabProvincialKeyPoints().then((res) => {
					 res.data.data.map((n)=>{
						this.pointDatas.push({
							title: n.labName,
							path: '/pointLab?id='+n.labId
						})
					})
				})
			}
			
		},
		methods: {
			goToMenuNext(data){
				// {
				// 	title: '动物实验中心入室申请',
				// 	path: '/aniQualification'
				// },
				// {
					
					this.currentSmallUrl = 'animal'
				if(data=='1'){
					this.$router.push({path:'/IACUC'})
				}
				if(data=='2'){
					this.$router.push({path:'/aniQualification'})
				}
				
				if(data=='3'){
					this.$router.push({path:'/animalApply'})
				}
				// 	title: 'IACUC审查',
				// 	path: '/IACUC'
				// },
				
				
				// {
				// 	title: '动物订购申请',
				// 	path: '/animalApply'
				// },
			},
			menuNextOver(data){
				if(data=='animalApply'){
					this.menuNext = true
				}
				else{
					this.menuNext = false
				}
			},
			menuNextOver2(data){
				if(data=='animalApply'){
					this.menuNext = false
				}
				
			},
			goToPath(data) {
				this.currentBigUrl = ''
				window.localStorage.setItem('currentBigUrl', this.currentBigUrl)
				if(data=='/pointLab'){
					AllLabProvincialKeyPoints().then((res)=>{
						this.$router.push({
							path: '/pointLab?id='+res.data.data[0].labId
						})
					})
				}
				
				this.$router.push({
					path: data
				})
			},
			goToPathNext(data) {
				this.currentBigUrl = this.currentSmallUrl
				window.localStorage.setItem('currentBigUrl', this.currentBigUrl)
				this.$router.push({
					path: data
				})
			},
			changeMenus(data) {
				
				if (data == 'center') {

					this.centerData = [{
							title: '实验室介绍',
							path: '/centerLab',
						},
						{
							title: '中心实验室入室申请',
							path: '/coreQualification'
						},
						{
							title: '资讯',
							path: '/notice'
						},
						{
							title: '仪器预约',
							path: '/instrument'
						},
						
						{
							title: '学习园地',
							path: '/downLoad'
						},
						{
							title: '门禁预约',
							path: '/accessControl'
						},
						{
							title: '耗材&项目',
							path: '/consumable'
						},

					]

					this.currentSmallUrl = 'center'
				}
				if (data == 'animal') {
					this.centerData = [{
							title: '中心介绍',
							path: '/animalLab'
						},
						{
							title: '动物实验伦理申请',
							path: '/IACUC'
						},
						
						// {
							
						
						{
							title: '资讯',
							path: '/notice2'
						},
						{
							title: '动物实验申请',
							path: 'animalApply'
						},
						{
							title: '仪器预约',
							path: '/instrument2'
						},
						// {
						// 	title: '动物实验中心入室申请',
						// 	path: '/aniQualification'
						// },
						
						
						
						// {
						// 	title: '动物订购申请',
						// 	path: '/animalApply'
						// },
						{
							title: '培训考核',
							path: '/trainSign'
						},
						
						{
							title: '下载中心',
							path: '/downLoad2'
						},
						{
							title: '门禁预约',
							path: '/accessControl2'
						},
						
						{
							title: '考试中心',
							path: '/exam'
						},
					]
					this.currentSmallUrl = 'animal'
				}
				if (data == 'point') {
					this.centerData = this.pointDatas
					this.currentSmallUrl = 'point'
				}
				// if(data=='orderLab'){
				// 	this.currentSmallUrl = ''
				// }
				this.navigateState = 1
			}
		}
	}
</script>

<style scoped>
	.menuItems {
		font-size: 18px;
		color: #FFFFFF;
		display: flex;
		align-items: center;
		flex-direction: column;
		cursor: pointer;
		min-width: 58px;
		position: relative;
		padding: 0 10px;
		margin-top: 16px;
	}

	.menuItems:hover {
		opacity: 0.8;
	}

	.

	/* menuItems:hover .hoverItem{
		width: 100% !important;
		position: absolute !important;
		bottom: -20px;
		background-color: rgba(11, 41, 77, 0.5);
	} */
	.menuItems:hover .hoverOrderItem {
		background-color: rgba(11, 41, 77, 0.5);
	}

	.indexItems {
		background-color: white !important;
	}

	.black {
		color: black !important;
	}

	.orderItems {
		background: #165FDC;
		width: 100% !important;
		position: absolute !important;
		bottom: -22px;
	}

	.naBox {
		/* border-left: 2px solid ; */
	}

	.actives {
		background: #165FDC !important;
		color: white;
	}

	.naItems:hover {
		background: #165FDC !important;
		color: white;
	}

	.naBoxIndex {
		background: rgba(5, 25, 47, 0.5) !important;
	}
	.yincang{
		display: none;
	}
	.kk:hover .yincang{
		display: block !important;
	}
	.kk:hover  .zhengc{
		display: none !important;
	}
	.kk{
		width: 40%;cursor: pointer;height: 60px;display: flex;align-items: center;padding-left: 54px;font-weight: 600;
		position: relative;
	}
	.ggs{
		width: 100%;font-size: 16px;display: flex;flex-wrap: wrap;margin-top: 24px;margin-bottom: 24px;
	}
	.hoverdd:hover{
		color: #165FDC !important;
	}
	.activesd{
		color: #165FDC !important;
	}
</style>
